/* eslint-disable react/no-array-index-key */
import React from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';

const ButtonContainer = styled.div`
  margin-bottom: 1em;
`;
const Padding = styled.span`
  &:not(:first-of-type) {
    margin-left: ${props => props.theme.space_inline_sm};
  }
`;

const propTypes = { children: PropTypes.node.isRequired };

/* A Utility to hold a group of buttons spaced */
export default function ButtonGroup({ children }) {
  // In case only one element is passed, make sure it is an array
  // (This might happen if a button is conditionally passed as a child)
  return (
    <ButtonContainer>
      {[...children].map((child, index) => <Padding key={index}>{child}</Padding>)}
    </ButtonContainer>
  );
}

ButtonGroup.propTypes = propTypes;
